// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface StatusOrbProps {
  tone: 'green' | 'amber' | 'red';
  className?: string;
}

const TONE_CLASSES: Record<StatusOrbProps['tone'], { disc: string; solid: string; ping: string }> =
  {
    green: {
      disc: 'bg-[hsl(var(--status-green)/0.12)]',
      solid: 'bg-[hsl(var(--status-green))]',
      ping: 'bg-[hsl(var(--status-green)/0.5)]',
    },
    amber: {
      disc: 'bg-[hsl(var(--status-amber)/0.12)]',
      solid: 'bg-[hsl(var(--status-amber))]',
      ping: 'bg-[hsl(var(--status-amber)/0.5)]',
    },
    red: {
      disc: 'bg-[hsl(var(--status-red)/0.12)]',
      solid: 'bg-[hsl(var(--status-red))]',
      ping: 'bg-[hsl(var(--status-red)/0.5)]',
    },
  };

export function StatusOrb({ tone, className }: StatusOrbProps): React.ReactElement {
  const c = TONE_CLASSES[tone];

  return (
    <div
      className={cn('flex h-11 w-11 items-center justify-center rounded-full', c.disc, className)}
      aria-hidden="true"
    >
      <span className="relative inline-flex h-4 w-4">
        <span
          className={cn(
            'absolute inline-flex h-full w-full rounded-full opacity-50 motion-safe:animate-ping',
            c.ping,
          )}
        />
        <span className={cn('relative inline-flex h-4 w-4 rounded-full', c.solid)} />
      </span>
    </div>
  );
}
